import { forwardRef } from 'react';
import { Quote as RadixQuote } from '@radix-ui/themes';
import type { RadixQuoteProps } from '@/types/radix-ui';

/**
 * Quote component - wrapper around Radix UI Quote
 * Provides semantic inline quotes
 */
export type QuoteProps = RadixQuoteProps;

const Quote = forwardRef<HTMLQuoteElement, QuoteProps>((props, ref) => {
  return <RadixQuote ref={ref} {...props} />;
});

Quote.displayName = 'Quote';

export { Quote };
